import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./Social.scoped.scss";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
  isDetailState,
  isEditState,
  isProfilePageState,
  isThroughMainState,
  parentsIdxState,
  popState,
  ShareArticleToggle,
  writingTypeState
} from "recoil/contentsAtom";
import axios from "axios";
import { BASE_PATH } from "api/commonApi";
import { withTranslation } from "react-i18next";
import ShareArticle from "components/community/Share/ShareArticle";
import { checkPosition, naverAuthorizePopUp } from "utils/CommonFunc";
import {
  headersState,
  isLoginStateSelector,
  isPrivacyAgreeState,
  naverAuthorizeUrl,
  userProfileKeyState
} from "recoil/userInfoAtom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCommentDots,
  faHeart as fullHeart,
  faShareNodes,
  faSpinner
} from "@fortawesome/free-solid-svg-icons";
import { faHeart } from "@fortawesome/free-regular-svg-icons";
import { useLoginCheck } from "hooks/useLoginCheck";

interface IProps {
  likeCount: number;
  idx: number;
  userLike: number;
  commentCount: number;
  categoryTitle?: string;
}

function Social(props: IProps) {
  const headers = useRecoilValue(headersState);
  const { service_code } = useParams();
  const isLoginState = useRecoilValue(isLoginStateSelector);
  const [articleToggle, setArticleToggle] = useRecoilState(ShareArticleToggle);
  const [isLikeLoading, setIsLikeLoading] = useState(false);
  const setIsThroughMain = useSetRecoilState(isThroughMainState);
  const setParentsIdx = useSetRecoilState(parentsIdxState);
  const setPopOpen = useSetRecoilState(popState);
  const setWritingType = useSetRecoilState(writingTypeState);
  const setIsEdit = useSetRecoilState(isEditState);
  const isDetail = useRecoilValue(isDetailState);
  const navigate = useNavigate();
  const isPrivacyAgree = useRecoilValue(isPrivacyAgreeState);
  const naverAuthorize = useRecoilValue(naverAuthorizeUrl);
  const [likeState, setLikeState] = useState({ isLike: 0, count: 0 });
  const isProfilePage = useRecoilValue(isProfilePageState);
  const userProfileKey = useRecoilValue(userProfileKeyState);
  const isNotLogin = useLoginCheck();

  const postLikeBoard = async (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!isLoginState.isLogIn) {
      isNotLogin();
      return;
    } else {
      if (!isPrivacyAgree) {
        checkPosition();
        naverAuthorizePopUp(naverAuthorize);
      }
    }

    const button = e.currentTarget as HTMLButtonElement;
    if (!isLikeLoading) {
      const api = isProfilePage
        ? `${BASE_PATH}/api/vfunlounge/profile/post/like?board_idx=${props.idx}`
        : `${BASE_PATH}/api/vfunlounge/${service_code}/like/${props.idx}`;
      try {
        setIsLikeLoading(true);
        let res = await axios.post(api, {}, { headers: { ...headers } });

        if (res.data.result === 1) {
          setLikeState({
            isLike: res.data.data.status ? 1 : 0,
            count: res.data.data.like_count
          });

          if (res.data.data.status) {
            button.classList.add("on");
          } else {
            button.classList.remove("on");
          }
        } else if (res.data.result === -88) {
          alert("존재하지 않은 프로필 유저입니다. 프로필 생성 후 이용해주세요");
          navigate(`/profile/${userProfileKey}`);
        }
      } catch (error) {
        console.log(error, "list like");
      } finally {
        setIsLikeLoading(false);
      }
    }
  };

  const onClickToggle = () => {
    setArticleToggle({
      [props.idx]: ![props.idx]
    });
  };

  const checkPostState = () => {
    if (!isDetail) {
      navigate(`${props.categoryTitle}/${props.idx}`);
      setIsThroughMain(true);
    } else {
      if (!isLoginState.isLogIn) {
        isNotLogin();
      } else {
        if (isPrivacyAgree) {
          setParentsIdx(0);
          setPopOpen(true);
          setWritingType("reply");
          setIsEdit(false);
        } else {
          checkPosition();
          naverAuthorizePopUp(naverAuthorize);
        }
      }
    }
  };

  useEffect(() => {
    setLikeState({ isLike: props.userLike, count: props.likeCount });
  }, []);

  return (
    <div className="social">
      <button className="heart" onClick={(e) => postLikeBoard(e)}>
        {!isLikeLoading ? (
          <>
            <FontAwesomeIcon
              icon={likeState.isLike === 0 ? faHeart : fullHeart}
            />
            <span className="num">{likeState.count.toLocaleString()}</span>
          </>
        ) : (
          <FontAwesomeIcon icon={faSpinner} pulse />
        )}
      </button>
      <button className="comments" onClick={checkPostState}>
        <FontAwesomeIcon icon={faCommentDots} />
        <span className="num">{props.commentCount.toLocaleString()}</span>
      </button>
      <div className="share-wrap">
        <button className="share" onClick={onClickToggle}>
          <FontAwesomeIcon icon={faShareNodes} />
        </button>
        {Object.keys(articleToggle).includes(String(props.idx)) ? (
          <ShareArticle idx={props.idx} />
        ) : null}
      </div>
    </div>
  );
}

export default withTranslation()(Social);
